var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeminiPro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_2868_2679)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9528 20.0147C24.5958 20.5251 20.4367 24.6963 19.9756 30C19.5423 24.7729 15.2413 20.4512 10 20.0225C15.2607 19.6238 19.5595 15.2316 19.9841 10C20.3298 15.2457 24.7222 19.6258 29.9528 20.0147Z",
    fill: "#DEA4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9528 20.0147C24.5958 20.5251 20.4367 24.6963 19.9756 30C19.5423 24.7729 15.2413 20.4512 10 20.0225C15.2607 19.6238 19.5595 15.2316 19.9841 10C20.3298 15.2457 24.7222 19.6258 29.9528 20.0147Z",
    fill: "#DEA4A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9528 20.0147C24.5958 20.5251 20.4367 24.6963 19.9756 30C19.5423 24.7729 15.2413 20.4512 10 20.0225C15.2607 19.6238 19.5595 15.2316 19.9841 10C20.3298 15.2457 24.7222 19.6258 29.9528 20.0147Z",
    fill: "#DEA4A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9528 20.0147C24.5958 20.5251 20.4367 24.6963 19.9756 30C19.5423 24.7729 15.2413 20.4512 10 20.0225C15.2607 19.6238 19.5595 15.2316 19.9841 10C20.3298 15.2457 24.7222 19.6258 29.9528 20.0147Z",
    fill: "#DEA4A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9528 20.0147C24.5958 20.5251 20.4367 24.6963 19.9756 30C19.5423 24.7729 15.2413 20.4512 10 20.0225C15.2607 19.6238 19.5595 15.2316 19.9841 10C20.3298 15.2457 24.7222 19.6258 29.9528 20.0147Z",
    fill: "#DEA4A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9528 20.0147C24.5958 20.5251 20.4367 24.6963 19.9756 30C19.5423 24.7729 15.2413 20.4512 10 20.0225C15.2607 19.6238 19.5595 15.2316 19.9841 10C20.3298 15.2457 24.7222 19.6258 29.9528 20.0147Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2868_2679",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA3E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiPro);
export default __webpack_public_path__ + "static/media/GeminiPRO.c998e328b818b2191bcf598086a1ce83.svg";
export { ForwardRef as ReactComponent };